angular.module('impactx').service('cookieService', CookieService);
CookieService.$inject = ['$cookies'];

function CookieService($cookies) {
    function setCookie(name, value, expireDays, isSecure) {
        var now;
        if(expireDays) {
            now = new Date();
            now.setTime(now.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        }
        var options = {
                expires: angular.isDate(now) ? now.toUTCString() : now,
                secure: isSecure ? isSecure : false
            }
        ;
        if (configData.useOnlySecureCookies) {
            options.samesite = 'none';
            options.secure = true;
        }

        $cookies.put(name, value, options);
    }

    function getCookie(name) {
        return $cookies.getObject(name);
    }

    function getCookieValue(name) {
        return $cookies.get(name);
    }

    function removeCookie(name) {

        if (configData.useOnlySecureCookies) {
            var options = {};
            options.samesite = 'none';
            options.secure = true;
            $cookies.remove(name, options);
        }
        else {
            $cookies.remove(name);
        }
    }

    return {
        setCookie: setCookie,
        getCookie: getCookie,
        removeCookie: removeCookie,
        getCookieValue: getCookieValue
    };
}